<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <div class="p-orderBoard__searchBox">
          <h2 class="title ml-3 mb-4">応募可能記事一覧</h2>
          <v-card class="searchOrdersArea" min-width="300px" outlined>
            <v-card-text>
              <v-form>
                <div>1. 検索対象サイトを選んでください</div>
                <v-select
                  v-model="siteKey"
                  :items="selectableSites"
                  item-text="name"
                  item-value="siteKey"
                  style="max-width: 150px"
                  class="ma-2"
                  clearable
                  label="対象サイト"
                />
                <v-divider />
                <div class="mt-3">2. 検索条件を入力してください</div>
                <v-text-field
                  v-model="searchQuery.title_or_query_cont"
                  label="キーワードで絞り込む"
                />
                <v-select
                  v-model="searchQuery.required_words_gteq"
                  :items="wordCountList"
                  placeholder="下限なし"
                  label="下限文字数"
                  clearable
                  class="mt-5"
                />
                <v-select
                  v-model="searchQuery.required_words_lteq"
                  :items="wordCountList"
                  placeholder="上限なし"
                  clearable
                  label="上限文字数"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" text @click="searchOrders">
                絞り込む
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-col>
      <v-col cols="6" class="mt-5">
        <div v-for="order in orders" :key="order.id">
          <OrderBoardCard :order="order" @clicked-card="showDialog(order)" />
          <v-divider />
        </div>
        <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。 </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。 </v-chip>
          </template>
        </infinite-loading>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          {{ order.title }}
        </v-card-title>
        <v-card-text>
          <OrderDetail :order="order" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="applyToOrder">
            応募する
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import OrderDetail from '@/components/commons/OrderDetail'
import OrderBoardCard from '@/components/commons/OrderBoardCard'
import headUtilsMixin from '@/mixins/head_utils'
import Qs from 'qs'
import { mapGetters } from 'vuex'
import { deserialize } from 'deserialize-json-api'

export default {
  components: {
    OrderDetail,
    OrderBoardCard,
    InfiniteLoading
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: '応募可能記事一覧',
      page: 1,
      orders: [],
      dialog: false,
      order: {},
      siteKey: null,
      searchQuery: {
        title_or_query_cont: null,
        required_words_gteq: null,
        required_words_lteq: null,
        status_eq: 0
      },
      infiniteId: +new Date(),
      wordCountList: [1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000],
      tagColors: ['primary', 'success', 'error', 'indigo']
    }
  },
  computed: {
    ...mapGetters('UserAuthStore', ['selectableSites'])
  },
  methods: {
    infiniteHandler ($state) {
      if (!this.siteKey) {
        $state.complete()
        return true
      }

      axios
        .get('/api/master/orders', {
          params: {
            page: this.page,
            site_key: this.siteKey,
            q: this.searchQuery
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const fetchedOrders = deserialize(data).data.filter(order => !!order.post)
          if (fetchedOrders.length) {
            this.page++
            this.orders = this.orders.concat(fetchedOrders)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    },
    showDialog: function (order) {
      this.order = order
      this.dialog = true
    },
    applyToOrder: function () {
      if (!this.siteKey) {
        return true
      }

      this.$store.dispatch('LoaderStore/displayLoader')

      axios
        .post(`/api/master/orders/${this.order.id}/apply`, {
          site_key: this.siteKey
        })
        .then(
          () => {
            const payload = {
              status: 200,
              message: '応募が完了しました。早速記事の執筆を始めましょう！'
            }
            this.searchOrders()
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
      this.dialog = false
    },
    searchOrders: function () {
      this.page = 1
      this.orders = []
      this.infiniteId += 1
    }
  }
}
</script>

<style scoped lang="sass">
.p-orderBoard__searchBox
  position: fixed
  margin: 20px

.searchOrdersArea
  @media only screen and (max-height: 613px)
    height: 65vh
    overflow: scroll
</style>
